import { DateTime } from 'luxon';

class TimetableHelper {
  static bucketSlots(slots, rows = [], rowIndex = 0) {
    if (!rows[rowIndex]) {
      rows[rowIndex] = [];
    }

    const conflictedSlots = [];
    for (const slot of slots) {
      const startTime = DateTime.fromISO(slot.startDate);
      let endTime = DateTime.fromISO(slot.endDate);
      if (endTime.second === 59) {
        endTime = endTime.plus({ seconds: 1 });
      }
      let hasConflict = false;
      for (const bucketedSlot of rows[rowIndex]) {
        const bucketedSlotStartTime = DateTime.fromISO(bucketedSlot.startDate);
        const bucketedSlotEndTime = DateTime.fromISO(bucketedSlot.endDate);
        if (startTime < bucketedSlotEndTime && endTime > bucketedSlotStartTime) {
          conflictedSlots.push(slot);
          hasConflict = true;
          break;
        }
      }
      if (!hasConflict) {
        rows[rowIndex].push(slot);
      }
    }

    if (conflictedSlots.length) {
      this.bucketSlots(conflictedSlots, rows, rowIndex + 1);
    }

    return rows;
  }

  static getCategory(item, sortBy) {
    switch (sortBy) {
      case 'activity':
        if (item.activity && item.activity.length > 0) {
          return item.activity[0].prefLabel || TimetableHelper.DEFAULT_CATEGORY;
        }
        return TimetableHelper.DEFAULT_CATEGORY;
      default:
        return TimetableHelper.DEFAULT_CATEGORY;
    }
  }
}

TimetableHelper.DEFAULT_CATEGORY = '';

export default TimetableHelper;
